module.exports = __webpack_public_path__ + "img/585239c.png";